import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { appendModel } from '../../../../features/site/siteSlice'
import { oauthConsts, OVERRIDE_ID_GMB } from '../../../utils/common'
import { getGmbVerificationStatus } from '../../../utils/Sites'

import SearchDropdown from '../../Layout/Common/SearchDropdown'

const INITIAL_STATE = {
    account: {},
    location: {}
}

function GoogleMyBusiness(props){
    const oauthConst = oauthConsts()

    const dispatch = useDispatch()
    const [state, setState] = useState(INITIAL_STATE)

    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)

    const AddAccParent = (p) => props.design === "onboarding" ? <div className="text-center">
        {p.children}
    </div> : <>{p.children}</>
    
    useEffect(() => {
        if(state.location !== INITIAL_STATE.location){

            let { account, location } = state 
            const map = {
                tokenId: oauthTokens.gmb?.id,
                accountId: account.name,
                accountName: account.accountName,
                locationId: location?.name?.includes("accounts") ? location.name : `${account.name}/${location.name}`,
                locationName: location.locationName || location.title,
                websiteUri: location.websiteUri
            }
            
            let sForm = {
                ...model.siteForm,
                attr: {
                    ...(model.siteForm?.attr ?? {}),
                    accounts: {
                        ...(model.siteForm?.attr?.accounts ? model.siteForm.attr.accounts : []),
                        gmb: map
                    }
                }
            }

            localStorage.setItem("gmbSelection", JSON.stringify({
                account: account.name,
                accountKey: account.key,
                location: map.locationId,
                locationKey: location.key,
                map: JSON.stringify({...map})
            }))

            dispatch(appendModel({siteForm: sForm}))

            props.onSelectionUpdated("gmb")
        }
    }, [state.location])

    const getVerificationStatus = async() => {
        const { response, error } = await getGmbVerificationStatus(model.siteForm.siteId)

        if(response){
            let sites = [
                ...model.sites
            ]
            let all = [...model.all]
            let newSite = {
                ...sites[model.siteActiveIdx],
                attr: {
                    ...sites[model.siteActiveIdx].attr,
                    accounts: {
                        ...(sites[model.siteActiveIdx].attr.accounts),
                        gmb: {
                            ...sites[model.siteActiveIdx].attr.accounts.gmb,
                            verificationStatus: response.verificationStatus
                        }
                    }
                }
            }

            const allIdx = all.findIndex(a => a.siteId === model.siteForm.siteId)

            if(allIdx){
                all[allIdx] = {...newSite}
            }

            sites[model.siteActiveIdx] = {...newSite}
            dispatch(appendModel({sites, all}))
        }
    }
    
    const { siteForm, sites, siteActiveIdx } = model
    const { account, location } = state

    const hrefOauth = `${oauthConst.gmbAuthURL}&state=${props.design === "onboarding" ? "/onboarding/" : "/admin/"}${siteForm.siteId}/gmb`
    const site = model?.sites.length > 0 && model?.siteActiveIdx >= 0  ? model?.sites[model?.siteActiveIdx] : null
    
    return <>
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && (!siteForm?.attr?.accounts?.gmb && oauthTokens?.gmb && !sessionStorage.getItem(OVERRIDE_ID_GMB)) && <>
            <div className="d-flex justify-content-end mb-3">
                <div className="btn-group">
                    <a href={hrefOauth} className="btn btn-lg btn-info">
                        <i class="fas fa-sync-alt"></i> Refresh
                    </a>
                </div>
            </div>
            <form>
                <div class="form-group">
                    <label for="acct">Account</label>
                    <select id="gbp-acct" className="form-control" onChange={(e) => setState(prev => ({...prev, location: INITIAL_STATE.location, account: {...oauthTokens?.gmb?.accounts[e.target.value], key: e.target.value}}))} value={account?.key}>
                        <option></option>
                        {oauthTokens?.gmb?.accounts.map((acct, key) => <option key={key} value={key}>{acct.accountName}</option>)}
                    </select>
                </div>
                <div class="form-group">
                    <label for="location">Location</label>
                    {props.design === "admin" ? <SearchDropdown 
                        value={location?.key}
                        defaultValue={""}
                        placeholder={"Choose location"} 
                        className={{
                            container: "w-100"
                        }}
                        onChange={(selected) => {
                            let key = account.locations.findIndex(l => l.name === selected.value)

                            setState(prev => ({...prev, location: {...account?.locations[key], key}}))
                        }}
                        options={account?.locations ? account?.locations?.map(loc => ({
                            label: `${loc.title ?? loc.locationName} (${loc.websiteUri?.substr(0, 50)}${loc.websiteUri?.length > 50 ? "..." : ""}`,
                            value: loc.name
                        })) : []} /> :
                    <select id="gbp-location" className="form-control" onChange={(e) => setState(prev => ({...prev, location: {...account?.locations[e.target.value], key: e.target.value}}))} value={location?.key}>
                        <option></option>
                        {account?.locations?.map((loc, key) => <option key={key} value={key}>
                            {loc.title ?? loc.locationName} ({loc.websiteUri?.substr(0, 50)}{loc.websiteUri?.length > 50 ? "..." : ""})
                        </option>)}
                    </select>}
                </div>
            </form>
        </>}
        {siteForm?.attr?.accounts?.gmb && <div>
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && sessionStorage.getItem(OVERRIDE_ID_GMB) && <h5 className="alert alert-info">
                Click the Save button to complete the reset token process
            </h5>}
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className={`d-flex justify-content-${isAdmin && siteForm?.attr?.accounts?.gmb?.refreshRequired ? 'between' : 'end'} mb-3`}>
                {isAdmin && siteForm?.attr?.accounts?.gmb?.refreshRequired && <div class="alert alert-danger mb-0" role="alert">
                    <strong>Next Alert Date:</strong> {siteForm?.attr?.accounts?.gmb?.refreshAlertDate}
                </div>}
                <div className="btn-group">
                    {!sessionStorage.getItem(OVERRIDE_ID_GMB) && siteForm?.attr?.accounts?.gmb?.refreshRequired && <button className="btn btn-lg btn-danger" onClick={() => props.onResetToken("gmb", hrefOauth)}>
                        <i class="fas fa-trash-alt"></i> Reset Token
                    </button>}
                    {isAdmin && <button className="btn btn-lg btn-outline-danger" onClick={() => props.onDeleteService("gmb")}>
                        <i class="fas fa-trash-alt"></i> Delete
                    </button>}
                </div>
            </div>}
            {isAdmin && <div className="d-flex justify-content-start">
                <i className="fas fa-id-badge mr-1 fa-1-5"></i>
                <strong className="mr-1">Token ID: </strong>
                <h5>{siteForm?.attr?.accounts?.gmb?.tokenId}</h5>
            </div>}
            <h3>
                <small class="text-muted">Account:</small> <span id="gbpAccountName">{siteForm?.attr?.accounts?.gmb?.accountName}</span>
            </h3>
            <h3>
                <small className="text-muted">Location:</small> <span id="gbpLocationName">{siteForm?.attr?.accounts?.gmb?.locationName}</span>
                {location?.websiteUri && <a href={location.websiteUri} className="ml-2 btn btn-sm btn-outline-primary" target="_blank">Test Page</a>}
            </h3>
            <h3>
                <small className="text-muted">Token Status:</small> <span className={siteForm?.attr?.accounts?.gmb?.refreshRequired ? "text-danger" : "text-success"}>
                    {siteForm?.attr?.accounts?.gmb?.refreshRequired ? "EXPIRED" : "ACTIVE"}
                </span>
                {siteForm?.attr?.accounts?.gmb?.refreshRequired && <button className="btn btn-sm btn-danger ml-2" onClick={() => props.onResetToken("gmb", hrefOauth)}>
                    <i class="fas fa-trash-alt"></i> Reset Token
                </button>}
            </h3>
            {props.design !== "onboarding" && <h3>
                <small className="text-muted">Verification Status:</small> <span className={!site?.attr?.accounts?.gmb?.verificationStatus ? "" : site.attr?.accounts?.gmb?.verificationStatus === "FAILED" ? "text-danger" : site?.attr?.accounts?.gmb?.verificationStatus === "COMPLETED" ? "text-success" : "text-warning"}>
                    {site?.attr?.accounts?.gmb?.verificationStatus ?? "N/A"}
                </span>
                <a className="badge badge-info ml-2" href="https://support.google.com/business/answer/7107242?hl=en" target="_blank" style={{fontSize: "8pt"}}>
                    <i className="fa fa-info"></i>
                </a>
                {(!model.reseller || (model.reseller && !model.isAffiliate)) && !siteForm?.attr?.accounts?.gmb?.refreshRequired && <button class="btn btn-sm btn-outline-info ml-2" onClick={() => getVerificationStatus()}>Check Status</button>}
            </h3>}
        </div>}
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && (!siteForm?.attr?.accounts?.gmb && !oauthTokens?.gmb) && <AddAccParent>
            <a class="btn btn-success btn-lg" href={hrefOauth}>Add Account</a>
        </AddAccParent>}
    </>
}

GoogleMyBusiness.defaultProps = {
    design: "admin",
    onSelectionUpdated: () => null
}

export default GoogleMyBusiness